/**
 * The app's NameNormalizer: lowercase, strip accents, every run of non-letters becomes one space,
 * trimmed. "Côte d’Ivoire" → "cote d ivoire". Only a–z survive, so letters that don't decompose
 * into a base letter and an accent (ø ł đ æ œ ı) are dropped by both the app and the web:
 * "Ørsted" → "rsted". That matches the app on purpose; data/test-cases/rules.json checks it.
 * If a case ever disagrees, change FOLD to match Swift; never change Swift.
 */
// Swift folds ß to "ss" (case-folding); no other letter folds differently.
const FOLD: Record<string, string> = { "ß": "ss" };

export function normalize(s: string): string {
  const folded = [...s.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase()].map((ch) => FOLD[ch] ?? ch).join("");
  let out = "";
  let pendingSpace = false;
  for (const ch of folded) {
    const code = ch.codePointAt(0)!;
    if (code >= 97 && code <= 122) {
      if (pendingSpace && out !== "") out += " ";
      pendingSpace = false;
      out += ch;
    } else {
      pendingSpace = true;
    }
  }
  return out;
}
